import { APP_MODE, ROLES, SUBSCRIPTION_PLANS } from '../../utils/constant'
import Icon from '../icon'

export const sideBarItemsList = [
  {
    title: 'Home',
    path: '/',
    icon: <Icon icon={'ant-design:home-filled'} />,
    modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER]
  },
  {
    title: 'Candidates',
    path: '/candidate-details',
    icon: <Icon icon="mdi:person-group" />,
    rolesExcluded: [ROLES.DEVELOPER],
    modeIncluded: [APP_MODE.HIRING]
  },
  {
    title: 'Contests',
    path: '/contests',
    icon: <Icon icon="solar:cup-bold" />
  },
  {
    title: 'Assessments',
    path: '/assessments',
    icon: <Icon icon="ic:outline-assessment" />
  },
  {
    title: 'Tenants',
    path: '/tenant-manager',
    icon: <Icon icon={'fa6-solid:users-gear'} fontSize={'1.2em'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'Attempts',
    path: '/attempts',
    icon: <Icon icon={'material-symbols:clear-all'} fontSize={'1.2em'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'Coupons',
    path: '/coupons',
    icon: (
      <Icon
        icon={'streamline:discount-percent-coupon-remix'}
        fontSize={'1.2em'}
      />
    ),
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'Invoices',
    path: '/tenant-invoices',
    icon: <Icon icon={'teenyicons:invoice-solid'} fontSize={'1.2em'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'Release Notes',
    path: '/release-notes',
    icon: <Icon icon={'garden:notes-stroke-12'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'Blacklisted Domains',
    path: '/blacklisted-domain',
    icon: <Icon icon={'mdi:domain-off'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'AI Token Usage',
    path: '/ai-token-usage',
    icon: <Icon icon={'carbon:ai-status'} fontSize={'1.2em'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'Library',
    icon: <Icon icon={'fluent:library-20-filled'} />,
    modeIncluded: [APP_MODE.HIRING],
    subItems: [
      {
        title: 'Challenges',
        path: '/challenges',
        icon: <Icon icon="material-symbols-light:swords-rounded" />
      },
      {
        title: 'Quiz',
        path: '/question-bank-management',
        icon: <Icon icon="fluent:book-question-mark-24-filled" />
      },
      {
        title: 'Databases',
        path: '/databases',
        icon: <Icon icon="material-symbols:database" fontSize={'1.55em'} />
      },
      {
        title: 'Resume Pools',
        path: '/resume-pool',
        roles: [ROLES.ADMIN, ROLES.MODERATOR, ROLES.CONTRIBUTOR],
        icon: <Icon icon="mdi:resume" fontSize={'1.55em'} />
      },
      {
        title: 'Application Forms',
        path: '/application-form',
        icon: <Icon icon="clarity:form-line" />,
        rolesExcluded: [ROLES.DEMO]
      },
      {
        title: 'Evaluation Templates',
        path: '/evaluation-template',
        icon: <Icon icon="qlementine-icons:template-16" />,
        rolesExcluded: [ROLES.DEMO]
      },
      {
        title: 'Email Templates',
        path: '/email-template',
        icon: <Icon icon="mdi:email-newsletter" />,
        rolesExcluded: [ROLES.DEMO]
      }
    ]
  },
  {
    title: 'Learning',
    icon: <Icon icon={'iconoir:learning'} />,
    rolesExcluded: [ROLES.DEVELOPER, ROLES.DEMO],
    modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER],
    subItems: [
      {
        title: 'Courses',
        path: '/courses',
        icon: <Icon icon={'dashicons:welcome-learn-more'} />,
        rolesExcluded: [ROLES.DEVELOPER, ROLES.LEARNER]
      },
      {
        title: 'Courses',
        path: '/learning/courses',
        icon: <Icon icon={'dashicons:welcome-learn-more'} />,
        modeIncluded: [APP_MODE.LEARNER]
      }
    ]
  },
  {
    title: 'Settings',
    path: '/settings',
    icon: <Icon icon="ph:gear-fill" />,
    modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER],
    subItems: [
      {
        title: 'Profile',
        path: '/settings/profile',
        icon: <Icon icon="iconamoon:profile-circle-fill" />,
        modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER]
      },
      {
        title: 'User Approvals',
        path: '/settings/user-approvals',
        icon: <Icon icon="fa7-solid:user-gear" fontSize={'1.1em'} />,
        roles: [ROLES.ADMIN, ROLES.DEVELOPER]
      },
      {
        title: 'Users',
        path: '/settings/users',
        roles: [ROLES.ADMIN],
        icon: <Icon icon="flowbite:users-solid" />
      },
      {
        title: 'Configurations',
        path: '/settings/config',
        roles: [ROLES.ADMIN],
        icon: <Icon icon="icon-park-outline:setting-config" />,
        plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
      },
      {
        title: 'Careers Settings',
        path: '/settings/careers-config',
        roles: [ROLES.ADMIN],
        icon: <Icon icon="streamline-plump:office-worker-solid" />,
        plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
      },
      {
        title: 'Workspaces',
        path: '/settings/workspaces',
        icon: <Icon icon="bi:person-workspace" />,
        roles: [ROLES.ADMIN],
        plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
      },
      {
        title: 'Integrations',
        path: '/settings/integrations',
        icon: <Icon icon="oui:integration-general" />,
        roles: [ROLES.ADMIN]
      }
    ]
  }
]
